import React, { useEffect, useState, useContext } from 'react';
import Modal from '../../../UI/Modal/Modal';
import css from './RemarkModal.module.css';
import tbl from '../../../../assets/Style/Table.module.css';
import { AppContext } from '../../../../providers/appProvider';
import Remark from "../../../../assets/Icon/Comment";
import Remove from '../../../../assets/Icon/Remove';
import Select from "react-select";
import { selectStyle } from './selectStyle';
import { useRemark } from '../../../../hooks/useRemark';
import { useUser } from '../../../../hooks/useUser';

const RemarkModal = ({
  containerService,
  cargoService, 
  remarkData, 
  isModalOpen,
  closeModal,
}) => {
 

    const defaultPageSize = 100; 
    const isFetch = true;   
    const roleId = null;  
  
  const { userService } = useUser(defaultPageSize, isFetch, roleId); 
  const [userOptions, setUserOptions] = useState([]);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const users = await userService.fetchList();   
        const options = users.map(user => ({
          label: `${user.firstname} ${user.lastname}`,
          value: user.id
        }));
        setUserOptions(options);
        console.log("Fetched Users:", users);  
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };
    
    fetchUsers();  
  }, []);  


    


  const { remarkService } = useRemark();
  const [remarks, setRemarks] = useState([]);

  const formatDate = (dateString) => {
    const purchasedAtDate = new Date(dateString);
    const months = ["იან", "თებ", "მარ", "აპრ", "მაი", "ივნ", "ივლ", "აგვ", "სექ", "ოქტ", "ნოე", "დეკ"];
    const day = purchasedAtDate.getDate();
    const month = months[purchasedAtDate.getMonth()];
    const year = purchasedAtDate.getFullYear();
    return `${day} ${month} ${year}`;
  };

  const colorOptions = ['#ff0000', '#feaec9', '#00ffff', '#ffff00', '#bcbd00', '#b5e51d', '#9ad9ea', '#7092bf', '#ffffb9', '#ff5f77'];
  const defaultColor = '';


  const [selectedColor, setSelectedColor] = useState(defaultColor);
  const [textValue, setTextValue] = useState("");
  const { appState, app } = useContext(AppContext);
 
  const [newRemark, setNewRemark] = useState({
    color: defaultColor,
    content: "",
    comment_author_id: 0,
    target_user_id: 0,
    container_id: 0,
    cargo_id: 0,
    remark_type: 0
  });


  
  const style = {
    width: '60px',
    height: '20px',
    color: '#64748b',
    backgroundColor: newRemark.color || '',
  };



  const fetchData = (id, type) => {
    remarkService.fetchRemarks(id, type)
    .then(data => {
      setRemarks(data);  
    })
    .catch(error => {
      app.setError("Failed to fetch remarks: " + error.message); 
    });
};
 
  useEffect(() => {
    if (isModalOpen && remarkData) {
 
         fetchData(remarkData.id, remarkData.remarkType)
 
         const newRemarkInit = {
            color: remarkData.color,
            content: "",  
            comment_author_id: 0,  
            target_user_id: 0,  
            remark_type: remarkData ? remarkData.remarkType : 0,
            container_id: 0,  
            cargo_id: 0 
        };

         if (remarkData.remarkType === 2) {
            newRemarkInit.cargo_id =  remarkData.id ;
         } else {
            newRemarkInit.container_id = remarkData.id ;
         } 
         setNewRemark(newRemarkInit);
    }
}, [isModalOpen, remarkData]);   

  
  const handleColorSelection = (newColor) => { 
    if (newColor === newRemark.color) { 
        setNewRemark({
        ...newRemark,
        color: ''
    });
     } else {
        setNewRemark({
        ...newRemark,
        color: newColor
    });
    }
   };
 
  const handleTextChange = (e) => {
    setNewRemark({
      ...newRemark,
      content: e.target.value
    });
  };

const addRemarkButtonHandle = () => {
    console.log("newRemark", newRemark);
    remarkService.addRemark(newRemark)
        .then((response) => {
            fetchData(remarkData.id, remarkData.remarkType);

            setNewRemark(prev => ({
                ...prev,
                content: ''
            }));

            containerService.fetchList();
            cargoService.fetch();

        })
        .catch((error) => {
            app.setError(`შეცდომა დამატებისას: ${error.message}`);
        });
};


  const onRemove = (id) => {
    remarkService.removeRemark(id)
      .then(response => {
         fetchData(remarkData.id, remarkData.remarkType)
//
      })
      .catch(error => {
        console.error(error);
      });
  };
  

  if (remarkData == null) {
    return 
  }

  const remarksSource = remarkData.remarkType === 2 ? remarkData.cargo : remarkData.container;
  console.log("remarkData", remarkData)
 
  return (
    <>  

      <Modal key={remarkData.id} size="large" isOpen={isModalOpen} onClose={closeModal}>
 
        <div>
          <div className={css.modalHead} >
            <h3>
              <span className={css.iconHead} > <Remark /></span>
              კომენტარი
            </h3>
          </div>
          <div className={tbl.table} style={{ minHeight: '50px' }}>
            <table>
              <thead>
                <tr>
                  <th className={css.id}>#</th>
                  <th>კომენტარი</th>
                  <th>ფერი</th>
                  <th>ავტორი</th>
                  <th>ადრესატი</th>
                  <th>თარიღი</th>
                  <th className={css.btntbl}></th>
                </tr>
              </thead>
              <tbody>
                {remarks && remarks.length > 0 ? (
                  remarks.map((remark, index) => (
                    <tr key={index}>
                      <td className={css.id}>{index + 1}</td>
                      <td>{remark.content}</td>
                      <td>
                        <div style={{ backgroundColor: remark.color, borderRadius: 5, display: 'block', height: 25, width: 100 }}></div>
                      </td>
                      <td>
                        {remark.comment_author && remark.comment_author.firstname && remark.comment_author.lastname ?
                          `${remark.comment_author.firstname} ${remark.comment_author.lastname}` :
                          ''}
                      </td>
                      <td>
                        {remark.target_user && remark.target_user.firstname && remark.target_user.lastname ?
                          `${remark.target_user.firstname} ${remark.target_user.lastname}` :
                          ''}
                      </td>
                      <td>{formatDate(remark.created_at)}</td>
                      <td className={css.btntbl}>
                        {app.hasPermission("COMMENT_DELETE") && (
                          <div className={css.btns}> 
                              <span className={css.removeBtn} onClick={() => onRemove(remark.id)}><Remove /> წაშლა</span> 
                          </div>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7">კომენტარი არ არსებობს</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
 


            <div className={css.form}>
                <textarea
                placeholder="კომენტარი"
                value={newRemark.content}
                onChange={handleTextChange}
                rows="7"
                cols="10"
                className={css.customtextarea}
                ></textarea>
            </div>

            <div style={{ width: "100%", display: "flex", justifyContent: "flex-end" , marginTop: "10px"}}>
                <div style={{ width: "100%", maxWidth: "300px" }}>
                <Select
                  styles={selectStyle}
                  options={userOptions}
                  value={userOptions.find(option => option.value === newRemark.target_user_id)}
                  onChange={(selectedOption) => {
                      setNewRemark(prevState => ({
                      ...prevState,
                      target_user_id: selectedOption ? selectedOption.value : 0,
                      }));
                  }}
                  placeholder="ადრესატი"
                  />
                </div>
            </div>
            

            <div className={css.colorSelector}>
                {colorOptions.map((color, index) => (
                <div
                    key={index}
                    className={`color-option ${newRemark.color === color ? 'selected' : ''}`}
                    style={{
                    backgroundColor: color,
                    border: `2px solid ${newRemark.color === color ? 'black' : 'transparent'}`,
                    borderRadius: '50%',
                    width: '40px',
                    height: '40px',
                    cursor: 'pointer',
                    display: 'inline-block',
                    margin: '0 8px',
                    }}
                    onClick={() => handleColorSelection(color)}
                ></div>
                ))}
            </div>


            
          {newRemark.color && newRemark.color.length > 0 && (
            <div style={{ color: 'rgb(100 116 139)' }}>
            არჩეული ფერი: <div style={style}></div>
            </div>
            )}

            {app.hasPermission("COMMENT_ADD") && (
              <div className={css.form}>
                <span onClick={addRemarkButtonHandle} className={css.btnPrimary}>შენახვა</span>
              </div>
            )}
 
 
        </div>
      </Modal>
    </>
  );
};

export default RemarkModal;
